import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { RiskIssueList } from '../../../../components/delivery/widgets/RiskIssueList';
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { SectionRenameCallout } from '../../_shared/components/SectionRenameCallout';
import { POTENTIAL_ISSUES_COPY } from '../../_shared/constants/sectionCopy';
import { RiskTab } from '../../Risk/RiskTab';
export function RiskPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "space-y-6",
            children: [
                /*#__PURE__*/ _jsx(SectionRenameCallout, {
                    storageKey: "specra-rename-callout-potential-issues",
                    message: POTENTIAL_ISSUES_COPY.formerlyCallout,
                    testid: Testids.deliveryRisk.renameCallout,
                    dismissTestid: Testids.deliveryRisk.renameCalloutDismiss
                }),
                /*#__PURE__*/ _jsx(RiskIssueList, {
                    programId: programId
                }),
                /*#__PURE__*/ _jsx(RiskTab, {
                    programId: programId
                })
            ]
        })
    });
}
